import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DeactivatedEmployee, EmployeeReadyForDeactivation } from '../types'

interface EmployeeDeactivationState {
    loading: boolean
    pendingEmployees: EmployeeReadyForDeactivation[]
    deactivatedEmployees: DeactivatedEmployee[]
    pageIndex: number
    historyPageIndex: number
    pageSize: number
    error: Error | string | null
}

const initialState: EmployeeDeactivationState = {
    loading: false,
    pendingEmployees: [],
    deactivatedEmployees: [],
    pageIndex: 1,
    historyPageIndex: 1,
    pageSize: 25,
    error: null
}

export const employeeDeactivationSlice = createSlice({
    name: 'employeeDeactivation',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        pendingEmployeesFetched: (state, action: PayloadAction<EmployeeReadyForDeactivation[]>) => {
            state.loading = false
            state.pendingEmployees = action.payload
            state.pageIndex = 1
            state.error = null
        },
        pendingEmployeesFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        deactivatedEmployeesFetched: (state, action: PayloadAction<DeactivatedEmployee[]>) => {
            state.loading = false
            state.deactivatedEmployees = action.payload
            state.historyPageIndex = 1
            state.error = null
        },
        deactivatedEmployeesFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        employeesDeactivated: (state) => {
            state.loading = false
            state.error = null
        },
        employeesDeactivationFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        pageIndexChanged: (state, action: PayloadAction<number>) => {
            state.pageIndex = action.payload
        },
        historyPageIndexChanged: (state, action: PayloadAction<number>) => {
            state.historyPageIndex = action.payload
        },
    }
})

export const {
    loading,
    pendingEmployeesFetched,
    pendingEmployeesFetchFailure,
    deactivatedEmployeesFetched,
    deactivatedEmployeesFetchFailure,
    employeesDeactivated,
    employeesDeactivationFailure,
    pageIndexChanged,
    historyPageIndexChanged
} = employeeDeactivationSlice.actions

export default employeeDeactivationSlice.reducer
